export default "__VITE_ASSET__cc02a61c__"